export function atualizarPerfil(nome, senhaAntiga, senha) {
  return {
    type: '@usuarioRelatorio/ATUALIZAR_PERFIL',
    payload: { nome, senhaAntiga, senha },
  };
}

export function atualizarPerfilSucesso(nome, senha) {
  return {
    type: '@usuarioRelatorio/ATUALIZAR_PERFIL_SUCESSO',
    payload: { nome, senha },
  };
}

export function atualizarPerfilFalhou() {
  return {
    type: '@usuarioRelatorio/ATUALIZAR_PERFIL_FALHOU',
  };
}
